// Chennai 2026 — each speaker paired with their topic, in agenda running order.
// Consumed by <AgendaShowcase/>, which lays the rows out in an alternating
// (zigzag) order: row 1 has the speaker on the left, row 2 on the right, etc.
//
// Co-presented talks list both speakers. Dr. Srikanth (stage host) is intentionally
// omitted, along with his Wi-Fi 8 topic.
//
// topic.videoId is the YouTube id of the session recording. When present the
// expanded row embeds the talk; when absent it falls back to topic.image.

export const chennaiAgenda = [
  {
    speakers: [
      { name: "Shivam Thakur", company: "Hewlett Packard Enterprise (Juniper)", image: "/images/shivam.png", linkedin: "https://in.linkedin.com/in/shivam-thakur-49978016a" },
    ],
    topic: {
      id: "mdu-wifi-excellence",
      title: "From RF Chaos to Wi-Fi Excellence: Designing High-Performance MDU Networks",
      category: "Network Design & Optimization",
      image: "/images/shivam-mdu-thumbnail.jpg",
      videoId: "qa0QbcY4WlA",
      abstract:
        `MDU (Multi-Dwelling Unit) Wi-Fi deployments present unique challenges due to high device density, overlapping networks, and increasing user expectations. This session explores how WiFi technologies such as OFDMA, BSS Coloring, Spatial Reuse, and Multi-Link Operation (MLO) can improve performance and spectrum efficiency, along with practical design considerations for building secure, scalable, and high-performance residential Wi-Fi networks.`,
    },
  },
  {
    speakers: [
      { name: "Susinder Gulasekaran", company: "Swinnovate", image: "/images/Susinder.png", linkedin: "https://www.linkedin.com/in/susinder" },
    ],
    topic: {
      id: "twt-best-battery-feature",
      title: "Target Wake Time: The Best Battery Feature Nobody Uses",
      category: "Power Save & Wi-Fi 6",
      image: "/images/chennai/susinder-twt-thumbnail.jpeg",
      videoId: "4VxiPMef6tE",
      abstract:
        `Collisions, unbounded listen times for downlink traffic delivery and unnecessary waking up to hear beacons have been the pain points of battery powered Wi-Fi clients for decades. Wi-Fi 6 introduced Target Wake Time (TWT) to achieve the dream of a scheduled service period. On paper it looked like the best feature Wi-Fi needs, and despite the Wi-Fi Alliance making TWT mandatory for Wi-Fi 6 certification, no client device actually uses it today. If we don't talk about our mistakes, we will never correct ourselves — no matter how many Wi-Fi generations come.`,
    },
  },
  {
    speakers: [
      { name: "Prem Thilagar", company: "Qualcomm", image: "/images/premthilagar.png", linkedin: "https://www.linkedin.com/in/prem-thilagar-2758817/" },
    ],
    topic: {
      id: "edge-ai-wifi-aps",
      title: "Edge AI and WiFi APs",
      category: "Edge AI",
      image: "/images/chennai/prem-edge-ai-thumbnail.png",
      videoId: "AkELfpEU05U",
      abstract:
        `The next stage of WiFi AP evolution takes it from higher speeds and feeds to providing edge services for many applications. As a part of the hardware evolution in WiFi APs, AI capabilities are planned to address latency and privacy in many applications. This talk will discuss some of the trends and the potential for such systems.`,
    },
  },
  {
    speakers: [
      { name: "Babu Subash Chandar C", company: "Zilogic Systems", image: "/images/BabuSubash.png", linkedin: "https://www.linkedin.com/in/babuenir" },
    ],
    topic: {
      id: "pinning-wifi-frames-linux",
      title: "Pinning down the Wi-Fi frames in Linux wireless stack",
      category: "Linux & Open Source",
      image: "/images/chennai/babusubhash-linux-thumbnail.jpeg",
      videoId: "sviAICwkfzU",
      abstract:
        `Linux open source wireless stack is gaining more popularity again in the wireless OEMs. This talk introduces the various open source wireless stack components, traces the Wi-Fi frames down to the component in the Linux wireless stack, and explains the reason behind each frame's origin at the corresponding component.`,
    },
  },
  {
    speakers: [
      { name: "Rasika Nayanajith", company: "Independent Expert", image: "/images/rasika.png", linkedin: "https://au.linkedin.com/in/rasikanayanajith" },
    ],
    topic: {
      id: "non-wifi-interference",
      title: "The Invisible Threat: Non-Wi-Fi Interference Exposed",
      category: "RF & Spectrum Analysis",
      image: "/images/chennai/rasika-interference-thumbnail.png",
      videoId: "w5J_AE30mto",
      abstract:
        `"The Invisible Threat: Non-Wi-Fi Interference Exposed" uncovers the hidden RF sources that silently degrade Wi-Fi performance. This session explores common non-Wi-Fi interferers across the 2.4GHz, 5GHz and 6GHz bands and practical techniques to identify, analyze, and mitigate their impact using real-world examples and spectrum analysis insights.`,
    },
  },
  {
    speakers: [
      { name: "Srihari Venkiteswaran", company: "Hewlett Packard Enterprise (Aruba)", image: "/images/srihari.png", linkedin: "https://www.linkedin.com/in/srihari-venkiteswaran-b48816a/" },
      { name: "Sruthik Issac", company: "Hewlett Packard Enterprise (Aruba)", image: "/images/sruthik.png", linkedin: "https://www.linkedin.com/in/sruthik-issac/" },
    ],
    topic: {
      id: "grounding-llms-wifi-rag",
      title: "Grounding LLMs with Wi-Fi Graph RAG and PCAP Logics",
      category: "AI & Troubleshooting",
      image: "/images/chennai/llm-rag-thumbnail.png",
      videoId: "k3a_0w8BlxQ",
      abstract:
        `Standard LLMs are notoriously terrible at infrastructure troubleshooting. While they excel at sounding confident, they routinely hallucinate 802.11 reason codes, ignore multi-dimensional constraints like WPA3 interoperability, and send engineers down hours-long rabbit holes during critical incidents. In enterprise networking, the cost of a hallucinated fix is simply too high — this talk shows how to ground answers in real evidence.`,
    },
  },
  {
    speakers: [
      { name: "Dr. Vijayalakshmi Chetlapalli", company: "Arista", image: "/images/vijayalakshmi.png", linkedin: "https://www.linkedin.com/in/vijayalakshmi-chetlapalli-7524ba5/" },
    ],
    topic: {
      id: "wifi7-client-security",
      title: "Unlocking Wi-Fi 7: The Real-World State of Client Security",
      category: "Wi-Fi 7 & Security",
      image: "/images/chennai/vijayalakshmi-wifi7-thumbnail.png",
      videoId: "_OK0KCAv7Bg",
      abstract:
        `Wi-Fi 7 brings dramatic gains in speed, capacity, and latency — but how much of its security promise actually reaches the client devices we use every day? This session takes a real-world look at the state of client security in Wi-Fi 7 deployments, examining where the standard's protections are honored, where they fall short in practice, and what it takes to close the gap between specification and field reality.`,
    },
  },
  {
    speakers: [
      { name: "Sudarsan Vasudevan", company: "Netgear", image: "/images/sudarshan.png", linkedin: "https://www.linkedin.com/in/sudavasu/" },
    ],
    topic: {
      id: "moores-law-met-wifi",
      title: "Moore's Law Met WiFi, and WiFi Won't Shut Up About It",
      category: "Silicon & AI",
      image: "/images/chennai/sudarshan-moorelaw-thumbnail.png",
      videoId: "H6hkyalSfiI",
      abstract:
        `Moore's Law promised more transistors every 18 months. Nobody promised they'd all go to good use. This talk traces what happened when WiFi access points inherited an exponentially growing compute budget — from single-core SoCs that could barely bridge a packet, to today's platforms with multiple radios, dedicated accelerators, and neural engines in the silicon — and asks whether WiFi became fundamentally smarter, or exponential transistor growth simply made inefficiency affordable.`,
    },
  },
  {
    speakers: [
      { name: "Tushar Nautiyal", company: "HFCL", image: "/images/tushar.png", linkedin: "https://www.linkedin.com/in/tusshar-nautiyal/" },
    ],
    topic: {
      id: "campus-wifi-case-study",
      title: "Large-scale Campus Wi-Fi Deployment: A Case Study",
      category: "Network Design & Deployment",
      image: "/images/chennai/tushar-campus-thumbnail.jpeg",
      videoId: "WSSGWDnonwY",
      abstract:
        `Large-scale campus Wi-Fi is often reduced to coverage, throughput, and capacity — but real deployments are far more complex. Modern campus networks behave like small digital cities: thousands of concurrent users, a diverse device mix, evolving learning models, and a relentless dependence on cloud apps. This session shares the journey of designing and deploying a large-scale campus Wi-Fi network for one of India's largest university ecosystems, serving over 130,000 students across a highly distributed environment.`,
    },
  },
  {
    speakers: [
      { name: "Pradeep Reddy", company: "Morse Micro", image: "/images/pradeepreddy.png", linkedin: "https://www.linkedin.com/in/pradeep-bhureddy/" },
    ],
    topic: {
      id: "wifi-halow-iot",
      title: "Wi-Fi HaLow: The 4th Lane of Wi-Fi for IoT",
      category: "IoT & Wi-Fi HaLow",
      image: "/images/chennai/pradeep-halow-thumbnail.png",
      videoId: "nWaDsj9AaFs",
      abstract:
        `Wi-Fi was built for indoors — but IoT goes beyond buildings. This session introduces Wi-Fi HaLow (IEEE 802.11ah), the sub-1 GHz extension to Wi-Fi purpose-built for IoT, delivering 1 km+ range, superior wall penetration, and up to 43 Mbps throughput — all within the same familiar Wi-Fi ecosystem.`,
    },
  },
  {
    speakers: [
      { name: "Yamini Shankar", company: "IIT Madras", image: "/images/yamini.png", linkedin: "https://www.linkedin.com/in/yamini-shankar-a6379b134/" },
    ],
    topic: {
      id: "lowfi-indoor-tracking",
      title: "Smarter Indoor Tracking with WiFi: Accurate Location with Lower Battery Use",
      category: "Localization & IoT",
      image: "/images/chennai/yamini-lowfi-thumbnail.jpeg",
      videoId: "3xnnMqar80k",
      abstract:
        `Indoor location tracking is becoming important for smart buildings, warehouses, factories, hospitals, and campuses. Wi-Fi-based localization is attractive because it reuses existing infrastructure, but continuous scanning quickly drains device batteries. This talk presents LowFI, a practical Wi-Fi localization approach that improves indoor positioning while intelligently deciding how many scans are needed and which access points are most useful for a given environment.`,
    },
  },
  {
    speakers: [
      { name: "Vishnu Kumar", company: "WiFi Nomads", image: "/images/vishnu.png", linkedin: "https://www.linkedin.com/in/vishnu435/" },
      { name: "Surya Prakash", company: "WiFi Nomads", image: "/images/surya.png", linkedin: "https://www.linkedin.com/in/surya-prakash-mullangi/" },
    ],
    topic: {
      id: "autonomous-wifi-testing-ai",
      title: "Autonomous Wi-Fi Testing: Why AI Needs the Expert in the Loop",
      category: "AI & Automation",
      image: "/images/chennai/autonomous-testing-thumbnail.png",
      videoId: "sbUBKP_F0iU",
      abstract:
        `AI can run your Wi-Fi tests, but without domain expertise baked in as guardrails, it will confidently give you wrong answers at the protocol level. Vishnu and Surya from Wi-Fi Nomads share their experience using AI for Wi-Fi testing, the hard lessons when AI operated without constraints, and how encoding domain knowledge as rules and oracle definitions transformed the outcome.`,
    },
  },
]
